import React, { useState } from "react";
import PageContainer from "../../layout/page-container/PageContainer";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";
import Logo from "../../images/logo12.png";
import LogoDark from "../../images/logo12.png";
import { Button, Icon } from "../../components/Component";
import { Spinner, FormGroup } from "reactstrap";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

import {authService} from "../../_services/auth";
import "./login.css";

const Register = ({ history }) => {
  const [passState, setPassState] = useState(false);
  const [loading, setLoading] = useState(false);
  const { errors, register, handleSubmit } = useForm();

  const handleFormSubmit = (submitData) => {
    setLoading(true);    
    authService.register(submitData).then(
      result=>{
        console.log(result);
        setLoading(false);
        history.push(`${process.env.PUBLIC_URL}/auth-login`);
      },
      err =>{
        console.log(err.toString());
        setLoading(false);
      }
    )
    
  };
  return (
    <React.Fragment>
      <Head title="Register" />
      <PageContainer>
        <main className="login-page register-page">
          <section className="login-showcase" aria-label="About MYUAE">
            <div className="login-showcase__glow login-showcase__glow--one" />
            <div className="login-showcase__glow login-showcase__glow--two" />
            <Link to={`${process.env.PUBLIC_URL}/`} className="login-brand login-brand--light" aria-label="MYUAE home">
              <img src={LogoDark} alt="MYUAE" />
            </Link>

            <div className="login-showcase__content">
              <span className="login-eyebrow"><i /> Start your UAE journey</span>
              <h1>Turn your business idea into reality.</h1>
              <p>
                Create your account and get a clear, guided path through company setup, licensing, and everything that follows.
              </p>

              <div className="login-benefits">
                <div><span><Icon name="check" /></span><p><strong>Get started quickly</strong>Your guided setup begins in minutes.</p></div>
                <div><span><Icon name="check" /></span><p><strong>Support at every step</strong>Expert help is always within reach.</p></div>
              </div>
            </div>

            <div className="login-showcase__footer">
              <span className="login-status"><i /> All systems operational</span>
              <span>One account for your entire journey</span>
            </div>
          </section>

          <section className="login-panel register-panel">
            <div className="login-panel__inner">
              <Link to={`${process.env.PUBLIC_URL}/`} className="login-brand login-brand--mobile" aria-label="MYUAE home">
                <img src={Logo} alt="MYUAE" />
              </Link>

              <div className="login-heading">
                <span className="login-heading__icon"><Icon name="user-add" /></span>
                <div>
                  <h2>Create your account</h2>
                  <p>Join MYUAE and start building your business.</p>
                </div>
              </div>

            <form className="is-alter login-form" onSubmit={handleSubmit(handleFormSubmit)}>
              <FormGroup className="login-field">
                <label className="form-label" htmlFor="name">
                  Full name
                </label>
                <div className="form-control-wrap">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Enter your full name"
                    ref={register({ required: true })}
                    className="form-control-lg form-control"
                  />
                  {errors.name && <p className="invalid">This field is required</p>}
                </div>
              </FormGroup>
              <FormGroup className="login-field">
                <div className="form-label-group">
                  <label className="form-label" htmlFor="default-01">
                    Email address
                  </label>
                </div>
                <div className="form-control-wrap">
                  <input
                    type="text"                   
                    id="default-01"
                    name="email"
                    ref={register({ required: true })}
                    className="form-control-lg form-control"
                    placeholder="you@company.com"
                  />
                  {errors.email && <p className="invalid">This field is required</p>}
                </div>
              </FormGroup>
              <FormGroup className="login-field">
                <div className="form-label-group">
                  <label className="form-label" htmlFor="password">
                    Password
                  </label>
                </div>
                <div className="form-control-wrap">
                  <a
                    href="#password"
                    onClick={(ev) => {
                      ev.preventDefault();
                      setPassState(!passState);
                    }}
                    className={`form-icon lg form-icon-right passcode-switch login-password-toggle ${passState ? "is-hidden" : "is-shown"}`}
                    aria-label={passState ? "Hide password" : "Show password"}
                  >
                    <Icon name="eye" className="passcode-icon icon-show"></Icon>

                    <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                  </a>
                  <input
                    type={passState ? "text" : "password"}
                    id="password"
                    name="password"
                    ref={register({ required: "This field is required" })}
                    placeholder="Enter your password"
                    className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"}`}
                  />
                  {errors.password && <span className="invalid">{errors.password.message}</span>}
                </div>
              </FormGroup>
              <FormGroup className="login-submit-wrap">
                <Button type="submit" color="primary" size="lg" className="btn-block login-submit" disabled={loading}>
                  {loading ? <Spinner size="sm" color="light" /> : <span>Create account <Icon name="arrow-right" /></span>}
                </Button>
              </FormGroup>
            </form>
            <div className="login-register">
              Already have an account?
              <Link to={`${process.env.PUBLIC_URL}/auth-login`}>
                Sign in instead
              </Link>
            </div>

              <div className="login-security"><Icon name="shield-check" /> Your information is securely protected</div>
            </div>
          </section>
        </main>
        <div className="login-footer"><AuthFooter /></div>
      </PageContainer>
    </React.Fragment>
  );
};
export default Register;
